import { css } from '@emotion/react';
import styled from '@emotion/styled';

export type LifecycleTagBadgeLevel =
    | 'super-callout'
    | 'colour-block'
    | 'property-status'
    | 'property-feature'
    | 'expired';

type TagWrapperProps = {
    badgeLevel?: LifecycleTagBadgeLevel;
};

export const TagWrapper = styled('p')<TagWrapperProps>(
    ({ theme: { fontSizes, colors, spacing, borderRadius }, badgeLevel }) => {
        let textColour = colors['text-body'];
        let borderColour = colors['neutral-4'];
        let backgroundColour = colors['graphic-background'];

        switch (badgeLevel) {
            case 'expired':
                backgroundColour = borderColour = colors['function-error'];
                textColour = colors.white;
                break;
            case 'property-status':
                borderColour = colors['tone-orange-t2'];
                textColour = colors['text-body'];
                break;
            case 'property-feature':
                borderColour = colors['neutral-4'];
                textColour = colors['text-body'];
                break;
            case 'colour-block':
                backgroundColour = borderColour = colors['tone-orange-t2'];
                textColour = colors['text-body'];
                break;
        }

        return css`
            background-color: ${backgroundColour};
            border: 1px solid ${borderColour};
            border-radius: ${borderRadius.pill};
            color: ${textColour};
            display: inline-block;
            font-size: ${fontSizes[0]};
            margin: 0 0 ${spacing['8px']} 0;
            padding: ${spacing['4px']} 0.75rem; /* 12px */
            text-transform: uppercase;
        `;
    }
);
